// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import CreateAccountForm from 'modules/onBoarding/components/CreateAccount'

const CreateAccount = (): ReactElement => {
  return (
    <DocumentTitle title={`Create An Account | ATD`}>
      <CreateAccountForm />
    </DocumentTitle>
  )
}

export default CreateAccount
